import { render } from "./SideMenu.vue?vue&type=template&id=a10780e8&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=a10780e8&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10780e8"]])

export default __exports__